import { createStore } from 'vuex'
function setCookie(c_name,value,expiredays){//存cookie
  var exdate=new Date()
  exdate.setDate(exdate.getDate()+expiredays)
  document.cookie=c_name+ "=" +escape(value)+
  ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
  }
  function getCookie(c_name){//获取cookie
  if (document.cookie.length>0)
    {
     var c_start=document.cookie.indexOf(c_name + "=")
    if (c_start!=-1)
      { 
      c_start=c_start + c_name.length+1 
      var c_end=document.cookie.indexOf(";",c_start)
      if (c_end==-1) c_end=document.cookie.length
      return unescape(document.cookie.substring(c_start,c_end))
      } 
    }
  return ""
  }
  function deleteAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}
export default createStore({
  state: {
    userInfo:{
      hasLogin:false,
      token:'',
      info:{},
      appid:''
    },
    token:'',
  },
  getters: {
  },
  mutations: {
    initInfo(state){
      if(localStorage.getItem('token')){
        state.token = localStorage.getItem('token')
      }
    },
    setToken(state,token){
      state.token = token;
      localStorage.setItem('token',token)
    },
    clearCookie(state) {
      setCookie('userInfo','',-1); 
      deleteAllCookies()
      state.userInfo.hasLogin = false;
      if(vmobile&&vmobile.clearCookies){
        vmobile.clearCookies()
      }
    },
    clearToken(state){
      state.token = '';
      localStorage.removeItem('token')
    },
    setInfo(state,data){
      state.userInfo.hasLogin = true;
      state.userInfo.info = JSON.parse(JSON.stringify(data));
      setCookie('userInfo',JSON.stringify(state.userInfo),365);
    },
    setAppid(state,appid){
      state.userInfo.appid = appid;
      setCookie('userInfo',JSON.stringify(state.userInfo),365);
    },
  },
  actions: {
  },
  modules: {
  }
})
